import { forwardRef } from 'react';
import { cn } from '@shared/utils';
import styles from './select.module.css';

interface SelectProps {
  className?: string;
  wrapperClassName?: string;
  selectClassName?: string;
  label?: string;
  name?: string;
  value?: string;
  onChange?: (value: string) => void;
  children?: React.ReactNode;
  required?: boolean;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>((props, ref) => {
  return (
    <div className={cn('h-full w-full', props.className)}>
      {props.label && <label className='mb-2 block w-fit font-medium text-black select-none max-md:text-[#4c4c4c80]'>{props.label}</label>}
      <div
        className={cn(
          'grid h-[50px] w-full appearance-none items-center rounded-lg border border-[#4c4c4c1a] bg-[#FAFAFA] text-[#0f0f11] outline-none after:mr-4 after:h-[0.5em] after:w-[0.8em] after:justify-self-end after:bg-[#4c4c4c80]',
          styles.wrapper,
          props.wrapperClassName,
        )}
      >
        <select
          ref={ref}
          className={cn(
            'font-inherit block h-full w-full cursor-pointer appearance-none border-none bg-transparent px-4 py-2 pr-10 text-inherit outline-none',
            styles.control,
            props.selectClassName,
          )}
          name={props.name}
          value={props.value}
          onChange={(e) => props.onChange?.(e.target.value)}
          required={props.required}
        >
          {props.children}
        </select>
      </div>
    </div>
  );
});
